<header class="c-foundation-cdn-header">
	<nav class="navbar navbar-fixed-top">
		<div class="container">
			<a class="navbar-brand" href="/foundationcdn">FoundationCDN</a>
			<a class="jsdelivr-logo" href="/"><img width="182" height="26" src="{{@shared.assetsHost}}/img/foundation-cdn/jsdelivr-logo.svg" alt="A free super-fast CDN for developers and webmasters!"></a>
		</div>
	</nav>

	<span id="forkongithub"><a target="_blank" rel="noopener noreferrer" href="https://github.com/jsdelivr/foundationcdn">Fork me on GitHub</a></span>
</header>
